<template>
    <DashboardContainer>
        <campaigns-list/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import CampaignsList from '../components/marketing/CampaignsList'

export default {
    name: 'emailCampaignsList',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        CampaignsList,
    }
}
</script>